"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M24 13.86c0-2.617-2.13-5.415-5.333-5.573C17 5.279 14.007 3.5 10.557 3.5c-4.062 0-8.263 2.67-8.263 7.139 0 3.137 2.723 4.42 2.839 4.474a.91.91 0 001.176-.388l1.557-2.867 1.126 2.18a.905.905 0 00.804.486c.34 0 .651-.188.805-.487l1.12-2.166 1.522 2.85a.91.91 0 001.22.372c.442-.23.61-.77.378-1.206l-2.335-4.37a.917.917 0 00-.805-.476.905.905 0 00-.799.487l-1.105 2.14-1.106-2.14a.908.908 0 00-1.601-.016l-1.899 3.496c-.503-.447-1.09-1.214-1.09-2.37 0-3.35 3.282-5.353 6.456-5.353 2.925 0 5.445 1.598 6.74 4.275.16.33.507.53.876.506.087-.006.118-.005.135-.004l.071.003c2.248 0 3.814 2 3.814 3.796 0 2.175-1.729 3.88-3.935 3.88-.872 0-1.726-.348-2.151-.672a.914.914 0 00-1.11.005c-.787.61-2.953 2.028-6.076 2.028-3.637 0-6.317-2-7.327-3.183a.912.912 0 00-1.273-.107.885.885 0 00-.108 1.258c.334.39 3.414 3.817 8.708 3.817 3.09 0 5.367-1.142 6.671-2.03a5.902 5.902 0 002.666.668c3.22 0 5.742-2.488 5.742-5.665z" }), "MyNintendo");
//# sourceMappingURL=MyNintendo.js.map